import { FC } from "react";
import {
  Box,
  createStyles,
  makeStyles,
  Typography,
  useMediaQuery,
} from "@material-ui/core";
import { Link } from "react-router-dom";

import { Button } from "components";
import { useAddedAccountsChecklistInfo } from "containers/AddedRoyaltyAccountsChecklist";
import * as routes from "routes";
import theme from "theme";

const useStyles = makeStyles(() =>
  createStyles({
    container: {
      textAlign: "left",
      maxWidth: "500px",
      [theme.breakpoints.up("md")]: {
        maxWidth: "50%",
      },
    },
    header: {
      fontSize: "1.8rem",
      fontWeight: theme.typography.fontWeightMedium,
      textTransform: "unset",
      textAlign: "center",
    },
  }),
);

const RoyaltyAccountActions: FC = ({}) => {
  const classes = useStyles();
  const { isChecklistComplete } = useAddedAccountsChecklistInfo();
  const isXsDown = useMediaQuery(theme.breakpoints.down("xs"));

  return (
    <Box display="flex" flexDirection="column" className={classes.container}>
      {isChecklistComplete ? (
        <>
          <Box>
            <Typography variant="h3" className={classes.header} gutterBottom>
              Checklist Complete!
            </Typography>
            <Typography>
              We’ll be in touch to discuss your deal options. In the meantime,
              read about our deal option types and how the process works.
            </Typography>
          </Box>
          <Box mt={1}>
            <Button
              variant="contained"
              customColor="green"
              fullWidth
              size="large"
              component={Link}
              to={routes.sellerAboutDealOptions()}
            >
              About Deal Options
            </Button>
          </Box>
          <Box mt={3}>
            <Typography>
              Have more accounts to connect? Continue to connect more accounts
              and increase your deal potential.
            </Typography>
          </Box>
          <Box mt={1}>
            <Button
              variant="outlined"
              customColor="green"
              fullWidth
              size="large"
              component={Link}
              to={routes.sellerAddRoyaltyAccount()}
            >
              {isXsDown
                ? "Add Royalty Accounts"
                : "Continue Adding Royalty Accounts"}
            </Button>
          </Box>
        </>
      ) : (
        <>
          <Box>
            <Typography variant="h3" className={classes.header} gutterBottom>
              Add More Royalty Accounts
            </Typography>
            <Typography>
              Adding all of your royalty accounts will increase the value of
              your deal options.
            </Typography>
          </Box>
          <Box mt={1}>
            <Button
              variant="contained"
              customColor="green"
              fullWidth
              size="large"
              component={Link}
              to={routes.sellerAddRoyaltyAccount()}
            >
              {isXsDown
                ? "Add Royalty Accounts"
                : "Continue Adding Royalty Accounts"}
            </Button>
          </Box>
          <Box mt={3}>
            <Typography>
              If you have added all of your royalty accounts and want to learn
              more about our deal options, click below.
            </Typography>
          </Box>
          <Box mt={1}>
            <Button
              variant="outlined"
              customColor="green"
              fullWidth
              size="large"
              component={Link}
              to={routes.sellerAboutDealOptions()}
            >
              About Deal Options
            </Button>
          </Box>
        </>
      )}
    </Box>
  );
};

export default RoyaltyAccountActions;
